import React from 'react'

import Container from 'app/components/base/Container'
import Skeleton from 'app/components/base/Skeleton'
import Stack from 'app/components/base/Stack'
import ReportUserBlock from 'app/features/Store/components/ReportUserBlock'
import StoreBusinessUserInfoFeature from 'app/features/Store/StoreBusinessUserInfoFeature'
import StoreUserInfoFeature from 'app/features/Store/StoreUserInfoFeature'
import { storeTabs } from 'app/utils/constants/tabs.constants'

import StoreTabs from '~/components/common/StoreTabs'
import NextSeo from '~/containers/NextSeo'

import MainLayout from '../MainLayout'

import StoreHeaderContainer from './components/StoreHeaderContainer'
import { useStoreLayout } from './hooks/useStoreLayout'

const StoreLayout: RFC = ({ children }) => {
  const {
    slug,
    title,
    isBusinessUser,
    lastSegmentPath,
    user,
    isFallback,
    userHasProducts,
    userLocation,
    userName,
    hideReportBlock,
    description,
    seoImageUrl
  } = useStoreLayout()

  return (
    <MainLayout isPoweredFooter={isBusinessUser}>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          ...(!!seoImageUrl && { images: [{ url: seoImageUrl }] })
        }}
        canonical={`store/${slug}/${lastSegmentPath}`}
      />

      <StoreHeaderContainer isBusinessUser={isBusinessUser}>
        {isBusinessUser && (
          <StoreBusinessUserInfoFeature
            avatarUrl={user?.avatar?.url}
            location={userLocation}
            loading={isFallback}
            rating={user?.rating}
            name={userName}
            storeDescription={user?.store_description}
            taxNumber={user?.tax_number}
          />
        )}

        {!isBusinessUser && (
          <StoreUserInfoFeature
            avatarUrl={user?.avatar?.url}
            location={userLocation}
            loading={isFallback}
            rating={user?.rating}
            name={userName}
            {...(!!user?.role && { role: user.role })}
          />
        )}
      </StoreHeaderContainer>

      <Container
        maxWidth="lg"
        sx={{
          mb: 3,
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <Stack>
          <Skeleton
            loading={isFallback}
            sx={{ width: { xs: '100%', md: '20%' }, height: 48 }}
          >
            {userHasProducts && <StoreTabs tabs={storeTabs} />}
          </Skeleton>

          <ReportUserBlock
            userId={String(user?.id)}
            loading={isFallback}
            hideBlock={hideReportBlock}
            sxText={{ display: { md: 'none', xs: 'block' } }}
          />

          {children}
        </Stack>

        <ReportUserBlock
          userId={String(user?.id)}
          loading={isFallback}
          hideBlock={hideReportBlock}
          sxText={{ display: { md: 'block', xs: 'none' } }}
        />
      </Container>
    </MainLayout>
  )
}

export default StoreLayout
